<template>
  <validation-observer ref="observer" tag="div">
    <oie-form-wrapper class="add-edit-machine-owner__form" @submit="handleSubmit">
      <div class="input-column__container">
        <div class="input-column">
          <validation-provider v-slot="{ errors }" rules="required" slim>
            <oie-base-input
              id="customer-name"
              v-model="customer.name"
              :label-text="`${tStatic('machineCustomerName')}*`"
              :error-messages="errors"></oie-base-input>
          </validation-provider>

          <oie-base-dropdown
            v-model="customer.ownerType"
            :enable-deselection="true"
            :use-full-width="true"
            :enable-add-option="true"
            :initial-text="tStatic('selectOwnerType')"
            :label-text="tStatic('machineOwnerType')"
            :options="machineOwnerTypes"
            @add-option="showAddOptionModal"></oie-base-dropdown>

          <oie-base-input id="customer-no" v-model="customer.endCustomerNumber" :label-text="`${tStatic('machineCustomerNo')}`"></oie-base-input>

          <oie-base-input
            id="customer-info"
            v-model="customer.info"
            :label-text="`${tStatic('otherInfo')}`"
            :textarea="true"></oie-base-input>
        </div>
        <oie-action-wrapper>
          <template #left>
            <oie-base-action
              v-if="withDelete"
              size="large"
              theme="destructive"
              @click="$emit('delete')">
              <template #iconPrepend>
                <oie-base-icon icon="trash-can" size="xs"></oie-base-icon>
              </template>
              {{ tStatic('deleteMachineOwner') }}
            </oie-base-action>
          </template>
          <oie-base-action size="large" theme="skeleton" @click="handleCancel">
            {{ tStatic('cancel') }}
          </oie-base-action>
          <oie-base-action size="large" type="submit">
            {{ tStatic('saveMachineOrOwner') }}
          </oie-base-action>
        </oie-action-wrapper>
      </div>
    </oie-form-wrapper>
  </validation-observer>
</template>

<script>
import myPages from '@/mixins/my-pages'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import httpService from '../../../../core/http-service'
import utils from '@/core/utils'

export default {
  mixins: [myPages],
  props: {
    withDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customer: {
        name: '',
        ownerType: '',
        endCustomerNumber: '',
        info: ''
      }
    }
  },
  computed: {
    ...mapGetters('myMachines', ['hasCurrentMachineOwner', 'currentMachineOwner', 'machineOwnerTypes'])
  },
  mounted() {
    if(this.hasCurrentMachineOwner) {
      this.customer = _.merge(this.customer, this.currentMachineOwner)
    }
  },
  methods: {
    ...mapActions('myMachines', ['addMachineOwner', 'setMyMachinesMetaData']),
    async handleSubmit() {
      const valid = await this.$refs.observer.validate()
      if(valid) {
        const addedOrEditedMachineOwner = await this.addMachineOwner(this.customer)
        this.customer.name = ''
        this.customer.endCustomerNumber = ''
        this.customer.info = ''
        this.$refs.observer.reset()
        this.$emit('save', addedOrEditedMachineOwner)
      } else {
        const errors = document.querySelectorAll('.add-edit-machine-owner__form .input__message--error')
        if (errors && errors.length > 0 && !utils.isElementInView(errors[0])) {
          errors[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      }
    },
    handleCancel() {
      this.$emit('cancel')
    },
    async showAddOptionModal($event) {
      this.publish('modal.show.add-option', { header: this.tStatic('addNewOptionHeader'),
        text: this.tStatic('addNewOptionDescription'),
        initialValue: $event,
        action:
          {
            text: this.tStatic('addNewOptionText'),
            handler: this.handleAddOption
          }
      })
    },
    async handleAddOption(newOption) {
      const response = (await httpService.post('my-machines/meta-data/owner-type', { ownerType: newOption })).data
      const ownerTypeId = _.findKey(response.customerTypes, type => type === newOption)
      if(ownerTypeId) this.customer.ownerType = ownerTypeId
      await this.setMyMachinesMetaData(response)
    }
  }
}
</script>

<style>

</style>
